import { makeAutoObservable } from 'mobx';

import { CalcSurface } from '../../../../../../typings/reality-capture/volumes/models';

export class LayerStore {
    target: CalcSurface | null = null;
    reference: CalcSurface | null = null;
    drawCount: number = 0;

    constructor() {
        makeAutoObservable(this);
    }

    setReference(reference: CalcSurface) {
        this.reference = reference;
    }

    getReference(): CalcSurface {
        return this.reference;
    }

    setTarget(target: CalcSurface) {
        this.target = target;
    }

    getTarget(): CalcSurface {
        return this.target;
    }

    incrementDrawCount() {
        this.drawCount += 1;
    }

    resetDrawCount() {
        this.drawCount = 0;
    }
}

export const layerStore = new LayerStore();
